import { connect } from 'react-redux';
import { doDonation } from '../actions';
import DonationInProgress from '../components/DonationInProgress';


const mapStateToProps = state => ({
  route: state.route
});

const mapDispatchToProps = dispatch => ({
  tryDonation: () => {
    dispatch(doDonation('DonationSuccess'));
  }
});


export default connect(mapStateToProps, mapDispatchToProps)(DonationInProgress);



/** WEBPACK FOOTER **
 ** ./src/containers/DonationInProgressContainer.jsx
 **/